import i18n from '@dms/i18n';

import {useVehicleFormContext} from '../hooks/useVehicleFormContext';
import {Field} from './primitives/Field';

export function DoorTypesChips() {
  const {catalogueApi} = useVehicleFormContext();
  return (
    <Field
      type="chips"
      name="doorCountCategory"
      label={i18n.t('entity.vehicle.labels.numberOfDoorsFull')}
      options={catalogueApi?.fullDoorCountOptions ?? []}
      isDeselectable
    />
  );
}
